export default class F {
  constructor(t = !1, s = []) {
    (this.tt = t), (this.$e = s), (this.tt = t), (this.$e = s);
  }
  ns(t) {
    (this.tt = this.tt && t.tt), this.$e.push(...t.$e);
  }
}
